import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-e', 'LetterE', [["path",{"d":"M15.25 7H9v5m6.25 5H9v-5m0 0h5","key":"svg-0"}]]);